import { startCase } from 'lodash/fp';

import {
  CheckMetadata,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import { DocumentSyntheticContentDetection } from 'dashboard/models/check';

export const computeDocumentSyntheticContentDetectionMetadata = (
  check: DocumentSyntheticContentDetection,
): CheckMetadata => {
  if (check.reasons && check.reasons.length > 0 && check.metadata) {
    const { 'detected-synthetic-content': detectedSyntheticContent } = check.metadata || {};

    return {
      metadata: createSimpleCheckMetadataArray([
        {
          label: 'Detected Synthetic Content',
          value: detectedSyntheticContent?.map((content) => startCase(content)).join(', ') || '-',
        },
      ]),
      hideIfVerificationPassed: true,
    };
  }

  return {
    metadata: [],
    hideIfVerificationPassed: true,
  };
};
